import { render, staticRenderFns } from "./BigClient.vue?vue&type=template&id=f37f1d6e&scoped=true&"
import script from "./BigClient.vue?vue&type=script&lang=js&"
export * from "./BigClient.vue?vue&type=script&lang=js&"
import style0 from "./BigClient.vue?vue&type=style&index=0&id=f37f1d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37f1d6e",
  null
  
)

export default component.exports